<template>
  <footer id="footer">
    <div class="inner">
      <ul class="icons">
        <li v-for="entry in entries" v-bind:entry="entry" v-bind:key="entry.id">
          <a :href="entry.url" :class="entry.icon">
            <span class="label">{{entry.text}}</span>
          </a>
        </li>
      </ul>
      <ul class="copyright">
        <li>© {{year}} Tobias Ruby</li>
        <li>
          <router-link to="/legal">Impressum & Datenschutz</router-link>
        </li>
        <li>
          Design:
          <a href="http://html5up.net">HTML5 UP</a>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
export default {
  data: function() {
    return {
      year: new Date().year,
      entries: [
        {
          url: "https://www.xing.com/profile/Tobias_Ruby",
          icon: "icon fa-xing",
          text: "XING"
        },
        {
          url: "https://www.linkedin.com/in/tobias-ruby",
          icon: "icon fa-linkedin",
          text: "LinkedIn"
        },
        {
          url: "https://www.instagram.com/tobiruby/",
          icon: "icon fa-instagram",
          text: "Instagram"
        },
        {
          url: "https://github.com/rubytobi",
          icon: "icon fa-github",
          text: "GitHub"
        },
        {
          url: "mailto:info@tobiasruby.de",
          icon: "icon fa-envelope-o",
          text: "Email"
        }
      ]
    };
  }
};
</script>